import { render, staticRenderFns } from "./BuildingsPage.vue?vue&type=template&id=3eac1a6e&scoped=true&"
import script from "./BuildingsPage.vue?vue&type=script&lang=js&"
export * from "./BuildingsPage.vue?vue&type=script&lang=js&"
import style0 from "./BuildingsPage.vue?vue&type=style&index=0&id=3eac1a6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eac1a6e",
  null
  
)

export default component.exports